// @ts-nocheck
import { cloneDeep } from 'taptap-tools/utils';

import * as baseCurrencyActions from '../actions/baseCurrency.actions';

const initialStore = {
  baseCurrencies: []
};

const actionsMap = {
  [baseCurrencyActions.SET_COUNTRY_BASE_CURRENCY]: (store, action) => {
    const {
      baseCurrencyData: { _id, ...baseCurrencyDataInfo }
    } = action.data;
    return {
      ...store,
      baseCurrencies: cloneDeep([...store.baseCurrencies.concat(baseCurrencyDataInfo)])
    };
  },
  [baseCurrencyActions.SET_BASE_CURRENCY]: (store, action) => {
    const {
      baseCurrencyData: { _id, ...baseCurrencyDataInfo }
    } = action.data;
    return {
      ...store,
      baseCurrencies: cloneDeep([...store.baseCurrencies.concat(baseCurrencyDataInfo)])
    };
  }
};

export default function reducer(store = initialStore, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(store, action) : store;
}
